module.exports = __webpack_public_path__ + "img/shield-x.11a2514c.svg";